import React, { useEffect } from "react";
import PageTitleSection from "../../components/reusable/PageTitleSection/PageTitleSection";
import "./AboutUs.css";
import TEXT from "../../utils/text/about.json";
import { useCurrentLanguage } from "../../hooks/useCurrentLanguage";

/**
 *
 * @returns About Us Page
 */
export default function AboutUs() {

  const { language } = useCurrentLanguage();

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    window.dataLayer.push({
      event: 'pageview'
    });
  }, []);

  return (
    <div className="au-container">
      <div className="au-page-title">
        <PageTitleSection
          title={TEXT["title"][language]}
          descriptionParagraphs={TEXT["description"][language]}
          image={"aboutUs.png"}
          callToActionElement={
            <div className="au-page-description">
              {TEXT["text"][language].map((p, key) => {
                if (key === 2)
                  return (
                    <p key={key}>
                      <strong>{p}</strong>
                    </p>
                  );
                return <p key={key}>{p}</p>;
              })}
            </div>
          }
        />
      </div>
    </div>
  );
}
